import React from 'react';
import { Link } from 'react-router-dom';

export default function Cardsforopping() {
  const mystyle = { minWidth: "19rem", minHeight: "19rem" };

  const jobs = [
    {
      title: "Hr",
      subtitle: "Hr Executive",
      salary: "₹18,000 – ₹30,000",
      qualification: "Minimum 12th Pass",
      gender: "Male & Female",
      work: "Full-Time",
      location: "Mumbai",
    eligibility: [
            "Good communication and convincing skills",
            "Ability to interact with candidates and stakeholders professionally",
            "Basic knowledge of recruitment and HR practices",
            "Target-oriented and capable of working in a fast-paced environment"
          ],

          responsibilities: [
            "Source candidates through job portals and social media platforms",
            "Conduct initial screening and interview coordination",
            "Maintain candidate databases and recruitment records",
            "Follow up with candidates throughout the hiring process",
            "Achieve recruitment targets and submit regular hiring reports"
          ]
    },
    {
      title: "Sales",
      subtitle: "Sales Executive",
      salary: "₹18,000 – ₹25,000",
      qualification: "Minimum Graduate",
      gender: "Male & Female",
      work: "Full-Time",
      location: "Mumbai",
      eligibility: [
      "Good communication and convincing skills",
      "Ability to build and maintain customer relationships",
      "Energetic, self-motivated, and target-oriented",
      "Basic knowledge of sales and marketing techniques"
    ],

    responsibilities: [
      "Identify and approach potential customers for business opportunities",
      "Promote and explain company products/services to clients",
      "Achieve daily, weekly, and monthly sales targets",
      "Maintain regular follow-ups and strong customer relationships",
      "Prepare sales reports and update the manager on sales activities"
    ]
    },
    {
      title: "Manager",
      subtitle: "Sales Manager",
      salary: "₹4 LPA – ₹6 LPA",
      experience: "3–5 Years in Loans & Insurance",
      gender: "Male",
      work: "Full-Time",
      // location: "Andheri East",
      eligibility: [
        "Bachelor's degree in Business, Marketing, or a related field",
        "Strong leadership, communication, and decision-making skills",
        "Experience in managing sales teams and business development",
        "Target-oriented mindset with excellent problem-solving abilities"
      ],

      responsibilities: [
        "Set sales goals and ensure achievement of monthly and annual targets",
        "Manage, train, and evaluate the performance of sales executives",
        "Identify new business opportunities and expand market presence",
        "Develop long-term relationships with clients and key stakeholders",
        "Track sales metrics and present performance reports to senior management"
      ]
    },
    // {
    //   title: "DSA",
    //   subtitle: "DSA Acquisition",
    //   salary: "₹5 LPA – ₹8 LPA",
    //   experience: "Proven experience in DSA Tie-ups",
    //   gender: "Male & Female",
    //   work: "Full-Time",
    //   location: "Andheri East",
    //   eligibility: [
    //     "Strong network and experience in DSA acquisitions",
    //     "In-depth knowledge of loan products & financial markets",
    //     "Excellent relationship-building & negotiation skills",
    //     "Ability to manage multiple DSAs and ensure performance",
    //   ],
    //   responsibilities: [
    //     "Identify, onboard & manage new DSA partners",
    //     "Build strong relationships to drive business through DSAs",
    //     "Ensure achievement of sales and revenue targets via DSAs",
    //     "Monitor and support DSA partners for smooth operations",
    //     "Report performance metrics and provide regular market insights"
    //   ]
    // }
  ];

  return (
    <div className="container mt-4">
      <div className="row align-items-center">
        {jobs.map((job, index) => (
          <div className="col-lg-3 mb-4" key={index}>
            <Link
              to="/Viewoppingcareer"
              state={{ job }}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div className="card" style={mystyle}>
                <div className="card-body">
                  <h5 className="card-title">{job.title}</h5>
                  <h6 className="card-subtitle mb-2 text-muted">{job.subtitle}</h6>
                  <p><strong className='text-muted'>Salary :</strong> {job.salary}</p>
                  {job.qualification && <p><strong className='text-muted'>Qualification :</strong> {job.qualification}</p>}
                  {job.experience && <p><strong className='text-muted'>Experience :</strong> {job.experience}</p>}
                  <p><strong className='text-muted'>Gender :</strong> {job.gender}</p>
                  <p><strong className='text-muted'>Work :</strong> {job.work}</p>
                  <p><strong className='text-muted'>Location :</strong> {job.location}</p>
                  <div className="arrow mt-2">
                    <i className="fa-solid fa-arrow-right"></i>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
